import './ExceptionsActionContainer.css';

import { Button, Icon } from '@nike/eds';
import { useDispatch, useSelector } from 'react-redux';
import { StoreDispatch } from '../../shared/store/Store';
import { findExceptions, retryExceptions, selectCheckedExceptions, selectIsExceptionsLoading } from '../../shared/store/reducers/OverviewReducer';
import { Exception } from '../../shared/Types';

export function ExceptionsActionContainer() {
    const dispatch: StoreDispatch = useDispatch();
    const selectedExceptions = useSelector(selectCheckedExceptions) as Exception[];
    const isExceptionsLoading = useSelector(selectIsExceptionsLoading) as boolean;

    const onClickRetry = () => {
        dispatch(retryExceptions(selectedExceptions))
            .then(() => dispatch(findExceptions()));
    }

    return (
        <div id="exceptions-action-container">
            <div id="action-button-container">
                <span className="eds-type--body-3">{selectedExceptions.length} items selected</span>
                
                <Button id="submit-button" onClick={onClickRetry} disabled={selectedExceptions.length === 0 || isExceptionsLoading}>
                    Retry Selected Exceptions
                    <Icon name="Replay" />
                </Button>
            </div>
        </div>
    )
}